module.exports = __webpack_public_path__ + "img/lifetime-logo-footer.e7d29989.svg";